import * as React from 'react';
import { useState, useCallback } from 'react';
import { useFragment } from 'react-relay';
import { SelectBox } from '@components/selectbox';
import { performanceOverviewCurrencySelectionFragment } from './PerformanceOverviewCurrencySelection.relay';
import type { PerformanceOverviewCurrencySelectionPropsType } from './types';

const PerformanceOverviewCurrencySelection: React.FC<PerformanceOverviewCurrencySelectionPropsType> = ( props ) => {
    const currencySelection = useFragment( performanceOverviewCurrencySelectionFragment, props.currencySelection );

    const [ value, setValue ] = useState( props.selected );

    const updateValue = useCallback( ( newValue: any ) => {
        setValue( newValue );
    }, [] );

    const handleSave = useCallback( () => {
        props.onSave( value );
    }, [ props.onSave, value ] );

    return (
        <div
            className="performance-currency-selection absolute left-0 top-0 z-50 h-[calc(100%+10px)] w-[calc(100%+300px)] -mt-2.5 bg-[rgba(250,250,250,0.95)] transition-transform duration-500 ease-in-out"
            style={{ transform: props.isVisible ? 'translateY(0)' : 'translateY(210%)' }}
        >
            <div className="performance-currency-selection-inner flex h-full w-full flex-col items-stretch justify-between p-[50px] pr-[320px] max-[550px]:h-auto">
                <a className="performance-currency-selection-close absolute right-[320px] top-[45px] cursor-pointer opacity-30 transition-opacity duration-500 hover:opacity-100" onClick={ props.onCancel } />
                <h2 className="performance-currency-selection-headline -ml-[31px] bg-[url(/static/front/assets/other-icons/money.png)] bg-left bg-no-repeat bg-[length:18px] pl-[31px]">{props.currencySelectionHeader}</h2>

                <div className="performance-currency-selection-config flex justify-between items-start max-[550px]:flex-wrap max-[550px]:[&_.SelectBox2]:mt-4 max-[550px]:[&_.SelectBox2]:mb-4 max-[550px]:[&_.SelectBox2]:w-full max-[550px]:[&_.SelectBox2]:min-w-0 max-[550px]:[&_.info]:w-full">
                    <SelectBox
                        selectBox={ currencySelection }
                        onChange={ updateValue }
                        selected={ value }
                    />

                    <div className='info w-1/2 text-sm text-[#939592] max-[550px]:w-full'>
                        {props.currencySelectionInfo}
                    </div>
                </div>

                <div className="performance-currency-selection-action border-t border-[#efefef] pt-2.5 max-[550px]:pt-0 max-[550px]:mt-2.5">
                    <button
                        className='float-right ml-2.5 inline-block cursor-pointer rounded-[30px] border border-black bg-white px-10 py-2.5 text-[15px] font-normal font-[BonnCaps,Arial,sans-serif] uppercase tracking-wide text-[#668272] outline-none my-2.5 [.no-bonncapps_&]:font-[Arial,sans-serif]'
                        onClick={ handleSave }
                    >
                        {props.currencySelectionSaveButtonText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export { PerformanceOverviewCurrencySelection };
